/* eslint-disable */
import messageTypes from '@ringcentral-integration/commons/enums/messageTypes';
export default {
  addLog: 'Registro',
  editLog: 'Editar registro',
  viewDetails: 'Ver detalles',
  addEntity: 'Crear nuevo',
  call: 'Llamar',
  text: 'Mensaje',
  conversation: 'Conversación',
  groupConversation: 'Conversación grupal',
  voiceMessage: 'Mensaje de voz',
  [messageTypes.voiceMail]: 'Mensaje de buzón de voz',
  [messageTypes.fax]: 'Fax',
  mark: 'Marcar como no leído',
  unmark: 'Marcar como leído',
  delete: 'Eliminar',
  faxSent: 'Fax enviado',
  faxReceived: 'Fax recibido',
  pages: 'páginas',
  page: 'página',
  preview: 'Ver',
  download: 'Descargar',
  mmsWithOneAttachment: 'MMS con 1 adjunto',
  mmsWithAttachments: 'MMS con {count} adjuntos',
} as const;

// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"conversation"@#@ @source: @#@"Conversation"@#@
// @key: @#@"groupConversation"@#@ @source: @#@"Group Conversation"@#@
// @key: @#@"voiceMessage"@#@ @source: @#@"Voice message"@#@
// @key: @#@"[messageTypes.voiceMail]"@#@ @source: @#@"Voice Mail"@#@
// @key: @#@"[messageTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"mark"@#@ @source: @#@"Mark as Unread"@#@
// @key: @#@"unmark"@#@ @source: @#@"Mark as Read"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"faxSent"@#@ @source: @#@"Fax sent"@#@
// @key: @#@"faxReceived"@#@ @source: @#@"Fax received"@#@
// @key: @#@"pages"@#@ @source: @#@"pages"@#@
// @key: @#@"page"@#@ @source: @#@"page"@#@
// @key: @#@"preview"@#@ @source: @#@"View"@#@
// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"mmsWithOneAttachment"@#@ @source: @#@"MMS with 1 attachment"@#@
// @key: @#@"mmsWithAttachments"@#@ @source: @#@"MMS with {count} attachments"@#@
